export default __webpack_public_path__ + "static/media/profile4.0e9a6a30.jpeg";